/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { AppService } from '../api.service';

@Injectable({
  providedIn: 'root'
})
export class SampleRequestService {
  sampleOrderList: any[]=[];
  global_loader=true;

  constructor(private _as:AppService) { }

  getSampleOrders(){
      
    const url = this._as.api_base_url+'ims/order-sample/';
    this._as.getRequest(url, true).subscribe(
      (res: any) => {
        this.sampleOrderList = res.sample_order_list;
        this.global_loader = false;
      },
      (err: any) => {
        if (err) {
          this.global_loader = false;
        }
      }
    )
  
}
}
